type JQueryEventTarget = {
  on: (eventName: string, handler: (event?: unknown) => void) => void;
  off: (eventName: string, handler: (event?: unknown) => void) => void;
};

type JQueryFactory = (target: Document) => JQueryEventTarget;

function getJQueryFactory(): JQueryFactory | null {
  const scopedWindow = window as Window & {
    jQuery?: unknown;
    $?: unknown;
  };
  const candidate = scopedWindow.jQuery || scopedWindow.$;

  return typeof candidate === 'function' ? candidate as JQueryFactory : null;
}

export function onDocumentModalEvent(
  eventName: string,
  handler: (event?: unknown) => void
): () => void {
  const nativeHandler = handler as EventListener;
  const jquery = getJQueryFactory();
  const jqueryTarget = jquery?.(document) ?? null;
  let disposed = false;

  document.addEventListener(eventName, nativeHandler);
  jqueryTarget?.on(eventName, handler);

  return () => {
    if (disposed) {
      return;
    }

    disposed = true;
    document.removeEventListener(eventName, nativeHandler);
    jqueryTarget?.off(eventName, handler);
  };
}
